module.exports = __webpack_public_path__ + "670dd4a79f33289c2baa89460aac121d.png";